export const DEFAULT_LOAD_COUNT_FAV = 15;

export const FAVORITE_STORE_NAME = 'navigation-favourite-store';
